import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import OrderFinalization from './OrderFinalization';
import { AuthContext } from '../App';

export default function CheckoutPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isAuthChecking } = useContext(AuthContext);
  
  useEffect(() => {
    // Wait for auth check to complete
    if (isAuthChecking) {
      return;
    }
    
    // Only redirect if not authenticated after checking is complete
    if (!isAuthenticated) {
      // No longer set returnUrl, always go to main page after login
      navigate('/login');
    }
  }, [navigate, isAuthenticated, isAuthChecking]);

  // Show loading while checking auth
  if (isAuthChecking) {
    return <div className="loading-auth">Sprawdzanie autoryzacji...</div>;
  }

  // Only render if authenticated
  return isAuthenticated ? <OrderFinalization /> : null;
} 